export { default } from './wrapperValue.js'



//////////////////
// WEBPACK FOOTER
// ./~/lodash-es/toJSON.js
// module id = 786
// module chunks = 67